import { MoveDataCard } from './DataCard/MoveDataCard';
import { Data } from './types/TypeData';
import  { FC, useContext, useEffect, useRef, useState} from 'react';
import { ModalContext, RenderContext } from './CreateContext';
import styles from ".././css/nonScrollbar.module.scss"

type Props = {
  moveData: Data[];
}

export const AutoScrollPage: FC<Props> = (props) => {
  const { moveData } = props;
  const {settings} = useContext(RenderContext);
  
  const scrollRef = useRef<HTMLDivElement>(null);
  const scrollIntervalRef = useRef<NodeJS.Timeout>();
  const [isScrollPaused, setScrollPaused] = useState(false);
  let scrollTimes= 0;
  const { isModalOpen} = useContext(ModalContext);
  const { setRerender} = useContext(RenderContext);

  // スクロール速度の取得
  const shareTilesScrollSpeed = settings.find(setting => setting.KEY_NAME === "share_tiles_scroll_speed");
  const scrollSpeed = typeof shareTilesScrollSpeed?.VALUE === 'number' ? shareTilesScrollSpeed.VALUE : 30


  useEffect(() => {

    const startAutoScroll = () => {
      if (!isScrollPaused && scrollRef.current&& !isModalOpen) {
        const { scrollHeight, clientHeight } = scrollRef.current;
        const maxScrollTop = scrollHeight - clientHeight - 40;

        scrollIntervalRef.current = setInterval(() => {
          if (scrollRef.current) {
            scrollRef.current.scrollTop += 1;
            if (scrollRef.current.scrollTop >= maxScrollTop ) {
              clearInterval(scrollIntervalRef.current!);
              // 一番下までスクロールしたら5秒後にtopに戻る
              scrollTimes += 1
              if(scrollTimes % 3 == 0){
                setRerender(false)
              }
              setTimeout(() => {
                if (scrollRef.current && !isModalOpen && !isScrollPaused) {
                  scrollRef.current.scrollTop = 0;
                  startAutoScroll();
                }
              }, 5000);
            }
          }
          // スクロールの速さをここで調整できる
        }, scrollSpeed);
      }
    };

    const handleMouseMove = () => {
      setScrollPaused(true);
      clearTimeout(scrollTimeoutId);
      scrollTimeoutId = setTimeout(() => {
        setScrollPaused(false);
      }, 5000);
    };

    const handleTouchStart = () => {
      setScrollPaused(true);
      clearTimeout(scrollTimeoutId);
      scrollTimeoutId = setTimeout(() => {
        setScrollPaused(false);
      }, 5000);
    };

    let scrollTimeoutId: NodeJS.Timeout;

    // レンダリングして3秒後に自動スクロールを開始する
    const timeoutId = setTimeout(() => {
      startAutoScroll();
    }, 3000);

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchstart', handleTouchStart);

    return () => {
      clearTimeout(timeoutId);
      clearInterval(scrollIntervalRef.current!);
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchstart', handleTouchStart);
    };
  }, [isScrollPaused,isModalOpen]);

  return (
    <div
      ref={scrollRef}
      style={{ height: `${window.innerHeight}px`, overflow: 'scroll', paddingRight:"20px"}}
      className={styles.nonScrollbar}
    >
      {window.innerHeight > window.innerWidth && <div style={{ margin: `${window.innerHeight * 0.22}px` }}></div>}
      <MoveDataCard moveData={moveData} />
    </div>
  );
};
